import React from 'react'

const createHOC = ({ Container }) => (Wrapped) => (props) => <Container {...props} component={Wrapped} />

export default createHOC